// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__NS7GH","title":"Info_title__1dVnU","selects":"Info_selects__2oPBn","requiredAsterisk":"Info_requiredAsterisk__1pDWt"};